import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ComponentServiceBundle } from '@app/core/services/base/component-service-bundle.service';
import { ClientUserUriBuilderParams, UserService } from '@app/core/services/user.service';
import { ClientUser } from '@app/shared/models/client-user';
import { BaseUpdateComponent } from '@app/shared/components/base/base-update.component';
import { SmpError } from '@app/shared/models/smp-error';
import { ContentStoreService } from '@app/core/services/content-store.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Client } from '@app/shared/models/client';
import { BaseList, BaseWithIdList } from '@app/shared/models/list';
import { UserAssignment } from '@app/shared/models/user-assignment';
import { UserRole } from '@app/shared/models/user-role';
import { UserCoreComponent } from '@app/shared/components/user/user-core/user-core.component';
import { UserAddressComponent } from '@app/shared/components/user/user-address/user-address.component';
import { UserAdditionalDataComponent } from '@app/shared/components/user/user-additional-data/user-additional-data.component';
import { UserClientSettingsComponent } from '@app/shared/components/user/user-client-settings/user-client-settings.component';
import { UserPermissionRolesComponent } from '@app/shared/components/user/user-permission-roles/user-permission-roles.component';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

@Component({
    selector: 'client-user',
    templateUrl: './client-user.component.html',
    styleUrls: ['./client-user.component.scss']
})
export class ClientUserComponent extends BaseUpdateComponent<ClientUser, ClientUserUriBuilderParams>
                                 implements OnInit {

    @Input()
    private client: Client;

    @Input()
    public assignments: BaseList<UserAssignment>;

    @Input()
    public roles: BaseWithIdList<UserRole>;

    @Output()
    public canceled = new EventEmitter();

    @ViewChild('userCoreComponent')
    public userCoreComponent: UserCoreComponent;

    @ViewChild('userAddressComponent')
    public userAddressComponent: UserAddressComponent;

    @ViewChild('userAdditionalDataComponent')
    public userAdditionalDataComponent: UserAdditionalDataComponent;

    @ViewChild('userClientSettingsComponent')
    public userClientSettingsComponent: UserClientSettingsComponent;

    @ViewChild('userPermissionRolesComponent')
    public userPermissionRolesComponent: UserPermissionRolesComponent;

    protected paramsIdNames = [];

    get user() {
        return this.updated;
    }

    set user(updated) {
        this.updated = updated;
    }

    constructor(protected componentServiceBundle: ComponentServiceBundle,
                protected userService: UserService,
                protected contentStoreService: ContentStoreService) {
        super(componentServiceBundle, userService);
    }

    public ngOnInit() {
        super.ngOnInit();
    }

    protected generateUriBuilderParams(): ClientUserUriBuilderParams {
        return new ClientUserUriBuilderParams(this.client, this.original);
    }


    // MAIN BUTTONS **************************************************************************************************

    public cancel(): void {
        this.canceled.emit();
    }

    public submit(): void {
        if (this.valid()) {
            this.user.address.copyPostalCodes();
            this.update();
        }
    }


    // VALIDATION **************************************************************************************************

    private valid(): boolean {
        const userCoreComponentValid = this.userCoreComponent.valid(true);
        const userAddressComponent = this.userAddressComponent.valid(true);
        const userPermissionRolesComponent = this.userPermissionRolesComponent.valid(true);

        return userCoreComponentValid &&
               userAddressComponent &&
               userPermissionRolesComponent;
    }

    public formToModel(): void {
        this.user.user_code = this.userAddressComponent.user_code.value;
        this.user.email = this.userCoreComponent.email.value;
    }

    protected handleError(error: HttpErrorResponse | Error | string): void {
        if (error instanceof HttpErrorResponse && (<SmpError>error.error).additional_code ===  'validation.duplicate.email') {
            this.userCoreComponent.email.setErrors( { exists: true });
        } else if (error instanceof HttpErrorResponse && error.status === 422) {
            this.userService.promptForTan()
                            .then((tan: string) => {
                    this.user.emailchange_tan = tan;
                    this.update();
                }).catch(() => {
                this.showSimpleErrorSnackbar(marker('user_management.dialog.tan.not_provided'));
            });
        }

        super.handleError(error);
    }

}
